import styles from './TopBarBtn.module.css';

const TopBarBtn = ({ text, icon, style, onClick }) => {
  return (
    <div className={styles.btn} style={style} onClick={onClick}>
      <div className={styles.icon}>{icon}</div>
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export default TopBarBtn;
